/**
 * Display helpers for instructor user objects coming back from /auth/me.
 *
 * The User schema migrated from a single `name` field to separate
 * `first_name` / `last_name`. Until every backend row is backfilled and
 * every client build is updated, these helpers prefer first/last but
 * fall back to splitting `name` so older sessions still render correctly.
 */

/**
 * Build the full display name "First Last" for a user.
 * @param {{ first_name?: string, last_name?: string, name?: string } | null | undefined} user
 * @returns {string}
 */
export function displayName(user) {
  if (!user) return "";
  const first = (user.first_name || "").trim();
  const last = (user.last_name || "").trim();
  if (first || last) return `${first} ${last}`.trim();
  return (user.name || "").trim();
}

/**
 * The user's first name only — used for greetings.
 * @param {{ first_name?: string, name?: string } | null | undefined} user
 * @returns {string}
 */
export function firstName(user) {
  if (!user) return "";
  const first = (user.first_name || "").trim();
  if (first) return first;
  return (user.name || "").trim().split(/\s+/)[0] || "";
}

/**
 * Single-character avatar initial for a user.
 * @param {{ first_name?: string, name?: string } | null | undefined} user
 * @returns {string}
 */
export function avatarInitial(user) {
  const first = firstName(user);
  return first ? first.charAt(0).toUpperCase() : "U";
}
